import { select, put, call } from 'redux-saga/effects';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;
const getCustomLayers = ({ customLayers }) => customLayers;

export function* fetchCustomLayers() {
  const serverConfig = yield select(getServerConfig);
  const customLayers = yield select(getCustomLayers);
  const path = `/layer/${serverConfig.namespace}`;
  const response = yield call(API, 'get', 'api', path);
  
  const remoteValues = response.layers.map((layer) => layer.key);
  const layersToRemove = Object.values(customLayers).reduce(
    (acc, customLayer) => {
      if (
        !remoteValues.includes(parseInt(customLayer.key, 10)) &&
        customLayer.saved
      ) {
        acc.push(customLayer);
      }
      return acc;
    },
    [],
  );

  for (let i = 0; i < layersToRemove.length; i += 1) {
    yield put({
      type: 'REMOVE_LOCAL_CUSTOM_LAYERS',
      payload: {
        key: layersToRemove[i].key,
      },
    });
  }

  yield put({
    type: 'UPDATE_CUSTOM_LAYERS',
    payload: { layers: response.layers },
  });
}
